import { render } from "./RecCameraIcon.vue?vue&type=template&id=90b255c8"
import script from "./RecCameraIcon.vue?vue&type=script&lang=js"
export * from "./RecCameraIcon.vue?vue&type=script&lang=js"

import exportComponent from "/home/forge/staging.virtualcp.app/releases/20260928150148/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__